var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "list-card",
      on: {
        click: function ($event) {
          return _vm.goDetail()
        },
      },
    },
    [
      _c("div", { staticClass: "card-header" }, [
        _c("div", { staticClass: "header-content" }, [
          _c("label", [_vm._v("直播时间")]),
          _c("span", [_vm._v(_vm._s(_vm.cardData.live_time))]),
        ]),
        _c(
          "div",
          { staticClass: "live-status" },
          [
            _c("el-image", {
              staticClass: "status-icon",
              attrs: { src: _vm.statusIcon, fit: "contain" },
            }),
            _c("span", { staticClass: "status-text", class: _vm.statusColor }, [
              _vm._v(_vm._s(_vm.statusText)),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("el-image", {
            staticClass: "live-cover",
            attrs: {
              src: _vm.cardData.live_cover || _vm.DefaultCover,
              fit: "cover",
            },
          }),
          _c("div", { staticClass: "live-info" }, [
            _c("h3", [_vm._v(_vm._s(_vm.cardData.title))]),
            _c("span", [_vm._v(_vm._s(_vm.cardData.type))]),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }